import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DowloadPdfService {

  public pdfSubject = new Subject();
  constructor() { }
}
